import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Divider,
} from "@mui/material";

import "./PL/PL.css";

import BasicDetails from "./PL/BasicDetails";
import Documents from "./PL/Documents";
import CreditWorthy from "./PL/CreditWorthy";
import CallLog from "./PL/CallLog";

const TabPanel = ({ children, value, index }) => {
  return value === index ? <Box className="tab-panel">{children}</Box> : null;
};

const PL = () => {
  const { randomId } = useParams();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    const fetchLead = async () => {
      try {
        const response = await fetch(
          `https://be.corebankers.in/telecalling_pl/${randomId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Failed to fetch lead: ${response.status}`);
        }

        const data = await response.json();
        setLead(data);
      } catch (error) {
        console.error("Error fetching lead:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLead();
  }, [randomId]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleUpdate = async (updatedData) => {
    try {
      await fetch("https://be.corebankers.in/telecalling_pl_update", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedData),
      });

      const refreshed = await fetch(
        `https://be.corebankers.in/telecalling_pl/${updatedData.random_id}`
      );
      const freshLead = await refreshed.json();

      setLead(freshLead);
    } catch (error) {
      console.error("Error updating and refetching lead:", error);
    }
  };

  if (loading)
    return <div className="pl-loading">Loading lead details...</div>;

  if (!lead)
    return (
      <div className="pl-error">
        No lead found for ID: {randomId}
      </div>
    );

  return (
    <Box className="pl-container">
      <Typography variant="h5" align="center" className="pl-title" gutterBottom>
        🧾 Personal Loan Process Flow
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Paper elevation={3} className="pl-tabs-wrapper">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          variant="fullWidth"
          className="pl-tabs"
        >
          <Tab label="Basic Details" />
          <Tab label="Documents" />
          <Tab label="Credit Worthy" />
          <Tab label="Lead Log" />
        </Tabs>
      </Paper>

      <Paper elevation={3} className="pl-content">
        <TabPanel value={tabIndex} index={0}>
          <BasicDetails lead={lead} onSave={handleUpdate} />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <Documents lead={lead} onSave={handleUpdate} />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
          <CreditWorthy lead={lead} onSave={handleUpdate} />
        </TabPanel>
        <TabPanel value={tabIndex} index={3}>
          <CallLog lead={lead} />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default PL;
